import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Moon, Brain, Flame } from 'lucide-react';
const painPoints = [{
  icon: <Activity size={24} className="text-sage-700" data-id="element-97" />,
  title: 'Cambios Inesperados',
  desc: 'Te miras al espejo y no reconoces esa zona abdominal, a pesar de comer igual.'
}, {
  icon: <Moon size={24} className="text-sage-700" data-id="element-98" />,
  title: 'Agotamiento Profundo',
  desc: "Amaneces cansada, sin energía, aunque sientas que hayas 'dormido' 8 horas."
}, {
  icon: <Brain size={24} className="text-sage-700" data-id="element-99" />,
  title: 'Neblina Mental',
  desc: 'Te sientes irritable, con dificultad para concentrarte y recordar cosas simples.'
}, {
  icon: <Flame size={24} className="text-sage-700" data-id="element-100" />,
  title: 'Sofocos Constantes',
  desc: 'Aparecen en el peor momento, interrumpiendo tu día y tus noches.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function EmpathySection() {
  return <section className="py-20 md:py-32 bg-cream-dark" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-104">
            No es falta de disciplina.
            <br data-id="element-105" />
            <span className="text-sage-700 italic" data-id="element-106">
              Es tu mapa hormonal que ha cambiado.
            </span>
          </h2>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-107">
            Si sientes que los métodos que antes te funcionaban hoy son
            inútiles, es porque tu cuerpo ya no responde a dietas extremas.
            Necesitas una estrategia específica para esta etapa.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-108">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-cream p-8 rounded-2xl shadow-sm border border-sage-100/50 hover:shadow-md transition-shadow" data-id="element-109">
              <div className="w-12 h-12 rounded-full bg-sage-100 flex items-center justify-center mb-6" data-id="element-110">
                {point.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-111">{point.title}</h3>
              <p className="text-charcoal-light leading-relaxed text-sm" data-id="element-112">
                {point.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}